module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1241.c0c7ede5.png";